import { formatISO, parseISO } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { formatDate } from 'date-fns/format';
import type { PickupSchedule } from 'src/types/personalInformation';

export const reformatDate = (str: string): string => {
  if (str && str !== '') {
    const utcDate = new Date(str);
    const jstDate = toZonedTime(utcDate, 'Asia/Tokyo');
    return formatDate(jstDate, 'yyyy/MM/dd');
  } else {
    return '';
  }
};

export const reformatDatetime = (str: string | number, withTime = true): string => {
  if (str && str !== '') {
    const utcDate = new Date(str);
    const jstDate = toZonedTime(utcDate, 'Asia/Tokyo');
    return formatDate(jstDate, withTime ? 'yyyy/MM/dd HH:mm' : 'yyyy/MM/dd');
  } else {
    return '';
  }
};

export const formatForBirthDate = (str: string): string[] => {
  if (str && str !== '') {
    const strArr = str.split('-');
    return strArr;
  } else {
    return [];
  }
};

export const formatYYYYMMDD = (date: Date) => {
  const utcDate = new Date(date);
  const jstDate = toZonedTime(utcDate, 'Asia/Tokyo');
  return formatDate(jstDate, 'yyyy-MM-dd');
};

export const formatYYYMMDDHHMMSS = (str: string): string => {
  if (str && str !== '') {
    const utcDate = new Date(str);
    const jstDate = toZonedTime(utcDate, 'Asia/Tokyo');
    return formatDate(jstDate, 'yyyy/MM/dd HH:mm:ss');
  } else {
    return '';
  }
};

export const formatAsJST = (date: Date) => {
  const dateString = formatISO(date);
  return dateString.replace(/(Z|[+-]\d{2}:\d{2})$/, '+09:00');
};

export const formatPickupScheduleForApi = (pickupSchedule: PickupSchedule) => {
  return {
    ...pickupSchedule,
    pickupDate: pickupSchedule.pickupDate?.split('T')[0] ?? null,
    dateOfLanding: pickupSchedule.dateOfLanding?.split('T')[0] ?? null
  };
};

/**
 * Resolves a date string to a local `Date` object that represents the same calendar date (Year-Month-Day)
 * as observed in the JST timezone (Asia/Tokyo).
 * This ensures the date part (Y-M-D) of the output matches the date observed in JST,
 * regardless of the input string's timezone or the runtime's local timezone.
 */
export const parseToMatchJstDate = (value: string | null) => {
  return typeof value === 'string' ? parseISO(formatYYYYMMDD(new Date(value))) : null;
};
